"use strict";
// Copyright © 2021 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageAdapter = void 0;
const validate_js_1 = __importDefault(require("validate.js"));
const demarked_1 = require("@d24/demarked");
const services_1 = require("../../services");
const adapter_1 = require("../_abstract/adapter");
const _contracts_1 = require("../_contracts");
const adapter_2 = require("../_helpers/adapter");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class ImageAdapter extends adapter_1.AbstractAdapter {
    /**
     * @inheritDoc
     */
    objectToToken(object, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const { content } = object;
        validate_js_1.default.validators.presence.message = '- [content.image] value is required, but none was provided';
        this.validate(content, {
            image: {
                presence: true,
                type: 'object'
            },
            'image.type': adapter_1.getRelatedTypeConstraint(services_1.RelatedType.File, true),
            'image.value': adapter_1.getIdentifierConstraint(true)
        });
        // Reset the error message to its default value.
        validate_js_1.default.validators.presence.message = undefined;
        const { caption, image } = content;
        if (!image || !image.value) {
            throw new Error('[image.value] is required, but none was provided');
        }
        // STORAGE HACK lines (53 - 76)
        // Values of keys: isAuthorChange, isCaptionChange and author (when image data isn't change) are not provided in ImageModule
        // and token is pars from ImageModule, and not form creating/editing modal this values are not provided
        // because of that there are added here from stored data.
        const old = storage.retrieve(String(image.value));
        let toStore;
        if (typeof old !== 'undefined') {
            toStore = {
                ...old,
                ...content
            };
        }
        else {
            toStore = {
                ...content
            };
        }
        if (!toStore.shortDesc) {
            toStore.shortDesc = caption;
        }
        storage.store(String(image.value), toStore);
        if (!toStore.shortDesc) {
            return {
                content: image.value,
                raw: `#PHOTO[ id: ${image.value} ]`,
                type: demarked_1.TokenType.Image
            };
        }
        return {
            content: image.value,
            meta: { desc: toStore.shortDesc },
            raw: `#PHOTO[ id: ${image.value} | desc: ${toStore.shortDesc} ]`,
            type: demarked_1.TokenType.Image
        };
    }
    /**
     * @inheritDoc
     */
    tokenToObject(token, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        validate_js_1.default.validators.presence.message = '- either [content] is required, but none was provided';
        this.validate(token, {
            content: adapter_1.getIdentifierConstraint(true)
        });
        // Reset the error message to its default value.
        validate_js_1.default.validators.presence.message = undefined;
        const imageModule = {
            ...adapter_2.getModuleBase(),
            content: {},
            driver: _contracts_1.ModuleDriver.Image
        };
        const id = token.content;
        if (typeof id === 'undefined') {
            throw new Error('[Image.adapter - tokenToObject] Image id not defined');
        }
        imageModule.content = {
            ...imageModule.content,
            image: {
                type: services_1.RelatedType.File,
                value: id
            }
        };
        const meta = storage.retrieve(String(id));
        if (typeof meta !== 'undefined') {
            const { action, author, caption, redirectExt, shortDesc } = meta;
            if (typeof author !== 'undefined') {
                imageModule.content = {
                    ...imageModule.content,
                    author
                };
            }
            if (typeof caption !== 'undefined') {
                imageModule.content = {
                    ...imageModule.content,
                    caption
                };
            }
            if (typeof shortDesc !== 'undefined') {
                imageModule.content = {
                    ...imageModule.content,
                    shortDesc
                };
            }
            if (typeof action !== 'undefined') {
                imageModule.content = {
                    ...imageModule.content,
                    action
                };
                if (action === 'link' && typeof redirectExt !== 'undefined') {
                    imageModule.content = {
                        ...imageModule.content,
                        redirectExt: redirectExt
                    };
                }
            }
        }
        return imageModule;
    }
}
exports.ImageAdapter = ImageAdapter;
//# sourceMappingURL=Image.adapter.js.map